import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PluggableMap } from 'ol';
import { Control } from 'ol/control';
import { Graticule } from 'ol/layer';
import { Stroke } from 'ol/style';

@Component({
    selector: 'app-graticle',
    templateUrl: './graticle.component.html',
    styleUrls: ['./graticle.component.css'],
    standalone: true,
    imports: [CommonModule]
})
export class GraticleComponent implements OnInit, AfterViewInit, OnDestroy {
  private elRef = inject(ElementRef);

  readonly map = input<PluggableMap>(undefined);

  active: boolean = false;
  control: Control;
  graticuleLayer: Graticule;

  ngOnInit(): void {
    this.graticuleLayer = new Graticule({
      strokeStyle: new Stroke({
        color: 'rgba(255,120,0,0.9)',
        width: 2,
        lineDash: [0.5, 4],
      }),
      showLabels: true,
      wrapX: false,
    });
  }

  ngAfterViewInit(): void {
    this.control = new Control({target: this.elRef.nativeElement.parentNode, element: this.elRef.nativeElement});
    this.map().addControl(this.control);
  }

  ngOnDestroy(): void {
    if(this.control == null)
    return;

    this.map().removeControl(this.control);
    this.deSelect();
  }

  toggleGraticle = () => {
    if (this.active) {
      this.deSelect();
    } else {
      this.select();
    }
  };

  deSelect(): void {
    this.active = false;
    this.map().removeLayer(this.graticuleLayer);
  }

  select(): void {
    this.active = true;
    this.map().addLayer(this.graticuleLayer);
  }
}
